<template>
    <div>
        <hr class="cart__sep">

        <div :data-element="'toggle_active_' + dataElement"
             class="cart__row">
            <div class="cart__name">Услуги:</div>
        </div>


        <div v-for="(item, key) in items"
             :key="'upasaleService' + key"
             class="cart__row">
            <div class="cart__grow">
                <div v-if="!isUpsaleProduct"
                     class="chbox">
                    <input type="checkbox"
                           v-if="item.IN_CART"
                           :id="item.ID"
                           checked
                           :data-element="'remove_' + dataElement"
                           :class="{'btn-wait': loader[item.OFFER_ID] }"
                           :disabled="loader[item.OFFER_ID]"
                           @click="removeItemNoModal(item.IN_CART_ID)"
                           class="chbox__input">

                    <input type="checkbox"
                           v-if="!item.IN_CART"
                           :id="item.ID"
                           :data-element="'add_' + dataElement"
                           :class="{'btn-wait': loader[item.OFFER_ID] }"
                           :disabled="loader[item.OFFER_ID]"
                           @click="addServiceToCart(item, parentCartId, item.QUANTITY)"
                           class="chbox__input">

                    <div class="chbox__label">
                        <span v-if="!item.IN_CART"
                              :data-element="'cart_service_title_' + key"
                              @click="addServiceToCart(item, parentCartId, item.QUANTITY, 'Y')"
                              class="cart__trigger">
                            {{ item.NAME }}
                        </span>
                        <span v-else
                              :data-element="'cart_service_title_' + key"
                              @click="$emit('openModal', 'service', item)"
                              class="cart__trigger">
                            {{ item.NAME }}
                        </span>
                    </div>
                </div>

                <div v-else
                     class="chbox">
                    <input type="checkbox"
                           v-if="!item.IN_CART"
                           :id="item.ID"
                           :data-element="'add_' + dataElement"
                           :class="{'btn-wait': loader[item.ID] }"
                           :disabled="loader[item.ID]"
                           @click="addProductToCart(item.ADD_TO_CART_ACTION, item, parentCartId)"
                           class="chbox__input">

                    <input type="checkbox"
                           v-if="item.IN_CART"
                           :id="item.ID"
                           checked
                           :data-element="'remove_' + dataElement"
                           :class="{'btn-wait': loader[item.ID] }"
                           :disabled="loader[item.ID]"
                           @click="removeItemNoModal(item.IN_CART_ID)"
                           class="chbox__input">


                    <div class="chbox__label">
                        <span v-if="!item.IN_CART"
                              :data-element="'cart_product_title_' + key">
                            {{ item.NAME }}
                        </span>
                        <span v-else
                              :data-element="'cart_product_title_' + key">
                            {{ item.NAME }}
                        </span>
                    </div>

                </div>
            </div>

            <div class="cart__right">
                <div class="cart__price">
                    <span v-if="item.hasOwnProperty('PRICE_ONCE') && item.PRICE_ONCE > 0"
                          class="cart__val">{{ formatPrice(item.PRICE_ONCE) }}</span>
                    <span v-if="item.hasOwnProperty('PRICE_MONTHLY') && item.PRICE_MONTHLY > 0"
                          :data-element="'cart_price_upsale_monthly_' + key"
                          class="cart__val">
                        {{ formatPrice(parseFloat(item.PRICE_MONTHLY) * parseFloat(item.QUANTITY)) }}
                    </span>
                    <span class="cart__units">руб./мес.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import priceFormatter from '../../../../lib/priceFormatter.js'
import ModalConfirmCart from "../ModalConfirmCart.vue";

export default {
    name: 'CartUpsellService',
    props: {
        items: {
            type: Array
        },
        dataElement: {
            type: String
        },
        parentCartId: {
            type: String
        },
        loader: {
            type: Object,
        },
        isUpsaleProduct: {
            type: Boolean
        }
    },
    data: function () {
        return {
            active: true,
        };
    },
    methods: {
        openModal: function (typeModal, item) {
            this.$emit('openModal', typeModal, item);
        },
        formatPrice: function (price) {
            return priceFormatter.format(price)
        },
        addServiceToCart: function (service, parentId, quantity, modal) {
            let t = this;

            if (modal) {
                t.$modal.show(ModalConfirmCart,
                    {
                        id: 'add_service',
                        body: service.PREVIEW_TEXT,
                        title: service.NAME,
                        okTitle: 'Выбрать',
                        cancelTitle: 'Закрыть',
                        confirmFunction: function () {
                            t.$emit('addServiceToCart', service.OFFER_ID, parentId, quantity);
                            document.getElementById(service.ID).checked = true
                        },
                        cancelFunction: function () {
                            t.loader.cart--
                        }
                    },
                    {
                        name: 'add_service',
                        adaptive: true,
                        height: 'auto',
                    })
            } else {
                t.$emit('addServiceToCart', service.OFFER_ID, parentId, quantity);
            }
        },
        addProductToCart: function (addToCartAction, product, parentCartId) {
            let t = this;
            t.$emit('addProductToCart', addToCartAction, product.ID, parentCartId);
        },
        toggleActive: function () {
            this.active = !this.active;
        },
        removeItemNoModal: function (itemId) {
            let t = this;
            t.$emit('removeItemNoModal', itemId, t.blockId);
        },
    },
    created: function () {
        var t = this;
        t.items.forEach(function (item) {
            t.$set(t.loader, item.OFFER_ID, false);
            t.$set(t.loader, item.ID, false);
        });
    }

}
</script>